import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative flex min-h-[88vh] items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=ethereal%20fantasy%20magical%20forest%20with%20glowing%20emerald%20and%20gold%20fairy%20lights%2C%20floating%20sparkles%20and%20fireflies%20drifting%20among%20giant%20trees%2C%20misty%20moonlight%20atmosphere%2C%20stylized%20artistic%20anime%20background%20illustration%2C%20deep%20emerald%20green%20and%20warm%20gold%20color%20palette%2C%20magical%20dreamy%20cinematic%20mood%2C%20high%20detail%20fantasy%20environment&width=1600&height=900&seq=hero-main&orientation=landscape"
        alt="梦幻森林中闪耀着金色与翠绿色妖精之光的奇幻场景"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/50" />

      <div className="relative z-10 mx-auto w-full max-w-4xl px-4 py-24 text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 backdrop-blur px-4 py-1.5 text-sm text-accent-200 border border-background-50/20">
          <i className="ri-magic-line" />
          妖精 / 精灵类动漫 · 角色百科与声优表专题
        </span>

        <h1 className="mt-6 font-heading text-3xl md:text-5xl font-black leading-tight text-background-50 drop-shadow">
          在光与林之间，<br className="md:hidden" />邂逅每一位妖精角色
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-sm md:text-base leading-7 text-background-100/90">
          妖精动漫网为你集中整理妖精、精灵类动漫作品的角色百科与详细声优表。想查动漫人物介绍、看角色人气榜，或确认某位角色的配音演员——按作品或角色名直接查找，资料集中、查找高效。
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/characters"
            className="flex w-full sm:w-auto items-center justify-center gap-2 rounded-full bg-accent-500 px-7 py-3 text-sm font-medium text-primary-900 whitespace-nowrap hover:bg-accent-400 transition-colors"
          >
            开始查角色
            <i className="ri-arrow-right-line" />
          </Link>
          <Link
            to="/seiyuu"
            className="flex w-full sm:w-auto items-center justify-center gap-2 rounded-full border border-background-50/40 bg-background-50/10 px-7 py-3 text-sm font-medium text-background-50 whitespace-nowrap hover:bg-background-50/20 transition-colors"
          >
            查看声优表
          </Link>
        </div>

        <dl className="mx-auto mt-12 grid max-w-lg grid-cols-3 gap-4">
          {[
            { value: '12+', label: '人气角色' },
            { value: '6', label: '作品专题' },
            { value: '10+', label: '收录声优' },
          ].map((s) => (
            <div key={s.label} className="rounded-xl bg-background-50/10 backdrop-blur border border-background-50/15 px-3 py-4">
              <dt className="order-2 mt-1 text-xs text-background-100/80">{s.label}</dt>
              <dd className="order-1 font-heading text-2xl md:text-3xl font-bold text-accent-200">{s.value}</dd>
            </div>
          ))}
        </dl>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 text-background-100/70 animate-bounce">
        <i className="ri-arrow-down-s-line text-2xl" />
      </div>
    </section>
  );
}